var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg3DcgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.5885,
    height: 15.5885,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 1 24.4294)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.7897,
    height: 10.7897,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 14.4741 16.5647)",
    fill: "black",
    fillOpacity: 0.46
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10.7897,
    height: 10.7897,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 5.13 11.1699)",
    fill: "black",
    fillOpacity: 0.46
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10.7897,
    height: 10.7897,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 5.13 11.1699)",
    fill: "black",
    fillOpacity: 0.46
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 10.7897,
    height: 10.7897,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 5.16492 15.1553)",
    fill: "#E0E0E0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 10.7897,
    height: 10.7897,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 5.16492 19.033)",
    fill: "#E0E0E0"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 15.5827,
    height: 15.5455,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 1 8.79126)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 15.5455,
    height: 15.6574,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 14.5371 16.564)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.88428L14.3884 16.6141L14.3884 32.1466L1 24.4168L1 8.88428Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DcgIcon);
export default __webpack_public_path__ + "static/media/3D CG Icon.ebb8b2f8ed8ca7d431198d1843c0747d.svg";
export { ForwardRef as ReactComponent };